import { Route, Routes } from 'react-router-dom'

import React from 'react'

import LoginLayout from './Component/LoginLayout'
import ILoginScreen from 'src/Modules/Auth/Login/Component/ILoginScreen'
import LoginOtp from 'src/Modules/Auth/OTP/LoginOtp'
import Login from "src/Modules/Auth/Login/Component/Login"
import LOtp from 'src/Modules/Auth/OTP/Component/LOtp'

const LoginsRoutes = () => {
    return (
        <>


            <Routes >
                <Route element={<LoginLayout />}>
                    <Route path="/" element={<ILoginScreen children={<Login/>} text='Login'/>} />
                    {/* <Route path="/otp" element={<LoginOtp />} /> */}
                    <Route path="/otp" element={<ILoginScreen children={<LOtp />} text=''/>} />
                </Route>
            </Routes>




        </>
    )
}

export default LoginsRoutes
